function SeSelect(el, urlParam) {
    this.el = el;
    this.urlParam = urlParam;
    this.activeOptions = {};
    this.changeEventListeners = [];
    this.selectToggleEl = this.el.querySelector('.jsSeSelectToggle');
    this.initialTitle = this.selectToggleEl.innerHTML;

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsSeSelectToggle')) {
            this.toggle();
        }
    });

    this.el.addEventListener('change', e => {
        if (e.target.checked) this.setActiveOption(e.target.value, e.target.dataset.name);
        else this.removeActiveOption(e.target.value, e.target.dataset.name);

        this.hide();
    });
}

SeSelect.prototype.toggle = function() {
    this.el.classList.toggle('open');
};

SeSelect.prototype.hide = function() {
    this.el.classList.remove('open');
};

SeSelect.prototype.setActiveOptions = function(optionKeys) {
    for (let i = 0; i < optionKeys.length; i++) {
        const optionEl = this.el.querySelector('input[value="' + optionKeys[i] + '"]');
        if (optionEl) this.setActiveOption(optionKeys[i], optionEl.dataset.name);
    }
}

SeSelect.prototype.setActiveOption = function(key, value) {
    if (typeof this.activeOptions[key] === 'undefined') {
        this.activeOptions[key] = value;

        this.updateUrl();
        this.callChangeEventListeners();
        this.setSelectLabel();
        this.el.querySelector('input[value="' + key + '"]').checked = true;
    }
};

SeSelect.prototype.removeActiveOption = function(key, value) {
    if (typeof this.activeOptions[key] !== 'undefined') {
        delete this.activeOptions[key];

        this.updateUrl();
        this.callChangeEventListeners();
        this.setSelectLabel();
    }
};

SeSelect.prototype.callChangeEventListeners = function() {
    for (let i = 0; i < this.changeEventListeners.length; i++) {
        this.changeEventListeners[i](this.activeOptions);
    }
};

SeSelect.prototype.addChangeEventListener = function(listener) {
    this.changeEventListeners.push(listener);
};

SeSelect.prototype.updateUrl = function() {
    const url = new Url;
    const values = Object.keys(this.activeOptions);

    if (values.length > 0) url.query[this.urlParam] = values.join(',');
    else delete url.query[this.urlParam];

    history.pushState(null, null, url.toString());
};

SeSelect.prototype.setSelectLabel = function() {
    const activeValues = Object.values(this.activeOptions);

    if (activeValues.length > 0) {
        this.selectToggleEl.innerHTML = activeValues.join(', ');
        this.el.classList.add('is-active');
    }
    else {
        this.selectToggleEl.innerHTML = this.initialTitle;
        this.el.classList.remove('is-active');
    }
};
